export const principles = {
  title: "Nossos Princípios",
  subtitle: "O que nos torna diferentes?",
  bookVisit: "Agende uma visita",
  items: {
    environment: {
      title: "Ambiente preparado",
      description: "Espaços projetados para promover autonomia, concentração e aprendizado ativo"
    },
    respect: {
      title: "Respeito mútuo",
      description: "Base da nossa comunidade educativa, promovendo relações saudáveis e resolução pacífica de conflitos"
    },
    learning: {
      title: "Aprendizado ativo",
      description: "As crianças constroem seu conhecimento através de experiências concretas e significativas"
    },
    international: {
      title: "Perspectiva internacional",
      description: "Educação trilíngue (espanhol, inglês, Galego) e multicultural"
    },
    attention: {
      title: "Atenção individualizada",
      description: "Proporção reduzida que nos permite adaptar ao ritmo e às necessidades de cada estudante"
    },
    development: {
      title: "Desenvolvimento integral",
      description: "Atenção equilibrada às capacidades acadêmicas, emocionais, sociais e físicas"
    }
  }
};
